<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <router-link :to="{ name: 'ServerList' }" class="btn btn-default float-right">{{$t('buttons.backToList')}}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="card">
            <template v-if="isLoading">
              <Loader></Loader>
            </template>
            <template v-else>
<!--              <div class="card-header">-->
<!--                <h4 class="card-title">{{$t('views.server.create.title')}}</h4>-->
<!--              </div>-->
              <div class="card-body">
                <ServerForm
                  :handle-submit="onSendForm"
                  :handle-update-field="updateField"
                  :values="item"
                  :errors="violations" />
              </div>
            </template>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import ServerForm from './Form'
import Loader from '../../../Layout/Loader'

const { mapGetters, mapActions } = createNamespacedHelpers('server/create')

export default {
  components: {
    Loader,
    ServerForm
  },

  data () {
    return {
      item: {}
    }
  },

  computed: mapGetters([
    'error',
    'isLoading',
    'created',
    'violations'
  ]),

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }

      this.$router.push({ name: 'ServerUpdate', params: { id: created['@id'] } })
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      let data = this.item
      data.port = parseInt(data.port)
      this.create(data)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
